import { type ButtonHTMLAttributes, forwardRef } from "react";
import { cn } from "./utils/cn";

export type ButtonVariant = "primary" | "accent" | "ghost" | "link";
export type ButtonSize = "sm" | "md" | "lg";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = "primary", size = "md", type = "button", className, children, ...rest }, ref) => (
    <button
      ref={ref}
      type={type}
      className={cn(
        "hui-btn",
        `hui-btn--${variant}`,
        size !== "md" && `hui-btn--${size}`,
        className
      )}
      {...rest}
    >
      {children}
    </button>
  )
);

Button.displayName = "Button";
